<app-block-ui [loading]="loading">
  <ng-container>
    <p>Učitavanje</p>
  </ng-container>
</app-block-ui>

<form [formGroup]="saveNipForm" #pTypeForm>
  <div class="main-card">
    <div class="card-header">
      <a class="main-btn back-btn" [routerLink]="['./../../']"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <section class="flex align-items-center">
        <ng-container
          *ngIf="nipForUpdate?.current_product_operation_rel_id !== null"
        >
          <button
            class="main-btn mr-2"
            type="button"
            (click)="onCancel()"
            *ngIf="started || stopped"
          >
            Otkaži <i class="pi pi-refresh"></i>
          </button>
          <button
            class="main-btn mr-2"
            type="button"
            (click)="onStart()"
            *ngIf="!started && nipForUpdate.enable_add_operations"
            [ngClass]="{
              disabled:
                stopped ||
                saveNipForm.controls.operation_id.invalid ||
                disabledStart
            }"
            [disabled]="
              stopped ||
              saveNipForm.controls.operation_id.invalid ||
              disabledStart
            "
          >
            Start <i class="pi pi-clock"></i>
          </button>

          <button
            class="main-btn mr-2"
            type="button"
            (click)="onStart()"
            *ngIf="!started && !nipForUpdate.enable_add_operations"
            [ngClass]="{
              disabled: stopped || !subOperationSelected || disabledStart
            }"
            [disabled]="stopped || !subOperationSelected || disabledStart"
          >
            Start <i class="pi pi-clock"></i>
          </button>

          <button
            class="main-btn mr-2"
            type="button"
            (click)="onStartPause()"
            *ngIf="started && nipForUpdate.enable_add_operations"
            [ngClass]="{
              disabled: pauseStart
            }"
            [disabled]="pauseStart"
          >
            Pauza start <i class="pi pi-play"></i>
          </button>

          <button
            class="main-btn mr-2"
            type="button"
            (click)="onStartPause()"
            *ngIf="started && !nipForUpdate.enable_add_operations"
            [ngClass]="{
              disabled: pauseStart
            }"
            [disabled]="pauseStart"
          >
            Pauza start<i class="pi pi-play"></i>
          </button>

          <button
            class="main-btn mr-2"
            type="button"
            (click)="onStopPause()"
            *ngIf="pauseStart && nipForUpdate.enable_add_operations"
            [ngClass]="{
              disabled: !pauseStart
            }"
            [disabled]="!pauseStart"
          >
            Pauza stop <i class="pi pi-pause"></i>
          </button>

          <button
            class="main-btn mr-2"
            type="button"
            (click)="onStopPause()"
            *ngIf="pauseStart && !nipForUpdate.enable_add_operations"
            [ngClass]="{
              disabled: !pauseStart
            }"
            [disabled]="!pauseStart"
          >
            Pauza stop <i class="pi pi-pause"></i>
          </button>

          <button
            class="main-btn mr-2"
            type="button"
            (click)="onStop()"
            *ngIf="started && nipForUpdate.enable_add_operations"
          >
            Stop <i class="pi pi-clock"></i>
          </button>

          <button
            class="main-btn mr-2"
            type="button"
            (click)="onStop()"
            *ngIf="started && !nipForUpdate.enable_add_operations"
          >
            Stop <i class="pi pi-clock"></i>
          </button>
        </ng-container>
        <button
          class="main-btn"
          type="submit"
          *ngIf="!pauseStart && nipForUpdate.enable_add_operations"
          (click)="onSaveNip()"
        >
          Snimi <i class="pi pi-save"></i>
        </button>

        <button
          class="main-btn"
          type="submit"
          *ngIf="!pauseStart && !nipForUpdate.enable_add_operations"
          (click)="onSaveNip()"
        >
          Snimi <i class="pi pi-save"></i>
        </button>
      </section>
    </div>
    <h3 class="card-title">RADNI NALOG</h3>
    <div class="card-body">
      <div class="grid">
        <div class="col-4">
          <div class="field w-100">
            <label>Naziv proizvoda</label>
            <input
              type="text"
              class="w-100"
              [value]="nipForUpdate?.product?.name"
              [disabled]="true"
              pInputText
            />
          </div>

          <div class="field w-100">
            <label>Šifra proizvoda</label>
            <input
              type="text"
              class="w-100"
              [value]="nipForUpdate?.product?.product_type?.name"
              [disabled]="true"
              pInputText
            />
          </div>

          <div class="field w-100">
            <label>Šarža broj</label>
            <input
              type="text"
              class="w-100"
              [value]="nipForUpdate?.batch"
              [disabled]="true"
              pInputText
            />
          </div>

          <div class="field w-100 flex flex-row">
            <div class="field w-100 mb-0">
              <label>Količina planirano</label>
              <input
                type="text"
                class="w-100"
                [value]="nipForUpdate?.planned_units"
                [disabled]="true"
                pInputText
              />
            </div>
            <div
              class="field w-100 mb-0 ml-2"
              *ngIf="!nipForUpdate?.active_time_tracker && chosenOperation"
            >
              <label>Količina spremno</label>
              <input
                type="text"
                class="w-100"
                [value]="
                  nipForUpdate?.produced_totals[chosenOperation]
                    ? nipForUpdate?.produced_totals[chosenOperation]
                    : ''
                "
                [disabled]="true"
                pInputText
              />
            </div>
            <div
              class="field w-100 mb-0 ml-2"
              *ngIf="nipForUpdate?.active_time_tracker"
            >
              <label>Količina spremno</label>
              <input
                type="text"
                class="w-100"
                [value]="
                  nipForUpdate.produced_totals[
                    nipForUpdate.active_time_tracker.product_operation_rel_id
                  ] != undefined
                    ? nipForUpdate.produced_totals[
                        nipForUpdate.active_time_tracker
                          .product_operation_rel_id
                      ]
                    : ''
                "
                [disabled]="true"
                pInputText
              />
            </div>
          </div>

          <div class="field w-100">
            <label>Tip pakovanja</label>
            <input
              type="text"
              class="w-100"
              [value]="nipForUpdate.packaging_type_id"
              [disabled]="true"
              pInputText
            />
          </div>

          <div class="field w-100">
            <label>Napomena</label>
            <textarea
              type="text"
              class="w-100"
              rows="3"
              [value]="nipForUpdate.note"
              [disabled]="true"
              pInputTextarea
            >
            </textarea>
          </div>
        </div>
        <div class="col-4">
          <div
            class="field w-100"
            *ngIf="
              (!nipForUpdate.active_time_tracker &&
                nipForUpdate?.enable_add_operations) ||
              (!nipForUpdate.active_time_tracker &&
                nipForUpdate?.enable_add_operations &&
                nipForUpdate?.available_prod_ops.length === 0)
            "
          >
            <label>Operacija [SVE]</label>
            <p-dropdown
              [options]="allOperations"
              formControlName="operation_id"
              (onChange)="choseFromAllOperations($event.value)"
              placeholder="Izaberi operaciju"
              optionLabel="name"
              optionValue="id"
              [showClear]="true"
            ></p-dropdown>
          </div>
          <div
            class="field w-100"
            *ngIf="
              editNipActive === false &&
              nipForUpdate?.enable_add_operations &&
              (!started || stopped)
            "
          >
            <label>Podoperacije</label>
            <p-dropdown
              [options]="allSubOperations"
              formControlName="suboperation_id"
              placeholder="Izaberi podoperaciju"
              optionLabel="name"
              optionValue="id"
              [showClear]="true"
            ></p-dropdown>
          </div>

          <div
            class="field w-100"
            *ngIf="
              !nipForUpdate.active_time_tracker &&
              !nipForUpdate?.enable_add_operations
            "
          >
            <label>Operacija</label>
            <p-dropdown
              [options]="nipForUpdate?.available_prod_ops"
              dataKey="nipForUpdate?.available_prod_ops[0].id"
              formControlName="product_operation_rel_id"
              (onChange)="choseOperationForWork($event.value)"
              placeholder="Izaberi operaciju"
              optionLabel="operation.name"
              optionValue="id"
            ></p-dropdown>
          </div>

          <div
            class="field w-100"
            *ngIf="
              !nipForUpdate?.enable_add_operations &&
              !nipForUpdate.active_time_tracker
            "
          >
            <label>Podoperacije</label>
            <p-dropdown
              [options]="allSubOperations"
              formControlName="suboperation_id"
              placeholder="Izaberi podoperaciju"
              optionLabel="suboperation.name"
              optionValue="suboperation.id"
              (onChange)="suboperationSelected()"
            ></p-dropdown>
          </div>

          <div class="field w-100" *ngIf="nipForUpdate.active_time_tracker">
            <label>Trenutna operacija</label>
            <input
              type="text"
              class="w-100"
              [value]="nipForUpdate?.active_time_tracker?.operation_name"
              disabled
              pInputText
            />
          </div>

          <div class="field w-100" *ngIf="timeStart">
            <label>Početak operacije</label>
            <input
              type="text"
              class="w-100"
              [value]="timeStart | date : 'dd.MM.yyyy h:mm:ss a'"
              disabled
              pInputText
            />
          </div>
          <div class="field w-100" *ngIf="timeStop">
            <label>Završetak operacije</label>
            <input
              type="text"
              class="w-100"
              [value]="timeStop | date : 'dd.MM.yyyy h:mm:ss a'"
              disabled
              pInputText
            />
          </div>

          <section *ngIf="timeStop">
            <div class="field w-100">
              <label>Vreme (s/m/s)</label>
              <span class="p-input-icon-right w-100">
                <i class="pi pi-clock"></i>
                <input
                  type="text"
                  class="w-100"
                  [value]="totalTime"
                  [disabled]="true"
                  pInputText
                />
              </span>
            </div>

            <div class="field w-100">
              <label>Proizvedena količina</label>
              <input
                type="text"
                class="w-100"
                formControlName="produced_amount"
                pInputText
                (change)="enableSave()"
              />
            </div>

            <!-- <div
              class="field w-100"
              *ngIf="saveNipForm.get('delay_reasons').value.length > 0"
            >
              <label>Vreme zastoja (s/m/s)</label>
              <span class="p-input-icon-right w-100">
                <i class="pi pi-clock"></i>
                <p-calendar
                  styleClass="w-100"
                  class="w-100"
                  [timeOnly]="true"
                  formControlName="delay_duration"
                  [defaultDate]="delayTime"
                  [showSeconds]="true"
                  (onSelect)="onChoseDelayTime($event)"
                  inputId="timeonly"
                ></p-calendar>
              </span>
            </div> -->

            <div class="field w-100">
              <label>Škart</label>
              <p-multiSelect
                #skart
                [options]="scrapReasons"
                formControlName="scrap_reasons"
                defaultLabel="Izaberi razlog"
                (onChange)="addReasonToForm($event, 'scrap_reasons')"
                styleClass="w-100"
                optionValue="code"
                optionLabel="name"
                selectionLimit="1"
              ></p-multiSelect>
            </div>

            <div class="field w-100 flex flex-row">
              <!-- <div class="field w-100 mb-0 mr-2">
                <label>Neusaglašeni proizvodi (kom)</label>
                  <input type="text" class="w-100"  pInputText />
              </div> -->
              <div class="field w-100 mb-0">
                <label>Škart (kom)</label>
                <input
                  type="text"
                  class="w-100"
                  formControlName="scrap_amount"
                  pInputText
                />
              </div>
            </div>

            <div class="field w-100">
              <label>Dokumentacija zahteva izmene</label>
              <section class="flex">
                <div class="field-radiobutton mr-3">
                  <input
                    type="radio"
                    formControlName="documentation_correct"
                    [value]="true"
                    (change)="enableSave()"
                  />
                  <label for="">Da</label>
                </div>
                <div class="field-radiobutton">
                  <input
                    type="radio"
                    formControlName="documentation_correct"
                    [value]="false"
                    (change)="enableSave()"
                  />
                  <label for="">Ne</label>
                </div>
              </section>
            </div>
          </section>
        </div>
        <div class="col-4">
          <div class="field w-100" *ngIf="timeStop">
            <label>Komentar</label>
            <textarea
              type="text"
              class="w-100"
              rows="18"
              formControlName="comment"
              pInputTextarea
            >
            </textarea>
          </div>
        </div>
      </div>
      <div class="grid" *ngIf="activeNip?.produced_totals_by_suboperation">
        <div class="col-12">
          <p-table
            [value]="activeNip?.produced_totals_by_suboperation"
            [rows]="50"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            styleClass="p-datatable-customers p-datatable-gridlines "
            [paginator]="true"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>Proces</th>
                <th>Operacija</th>
                <th>Planirana količina</th>
                <th>Proizvedena količina</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-operation>
              <tr>
                <td>
                  {{ operation?.operation_name }}
                </td>
                <td>
                  {{ operation?.name }}
                </td>

                <td>
                  {{ nipForUpdate?.planned_units }}
                </td>
                <td>
                  {{ operation?.produced_amount }}
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="4">Ni jedna operacija nije pronađena.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</form>

<p-dialog
  header="Kraj pauze"
  [(visible)]="displayModal"
  [modal]="true"
  [style]="{ width: '30rem', height: '40rem' }"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
>
  <form
    [formGroup]="delayReasonsForm"
    (ngSubmit)="onSavePause()"
    #pTypeForm
    class="dialog-form"
  >
    <div class="field w-100">
      <label>Zastoj</label>
      <p-multiSelect
        [options]="delayReasons"
        defaultLabel="Izaberi razlog"
        formControlName="delay_reasons"
        (onChange)="addReasonToForm($event, 'delay_reasons')"
        styleClass="w-100"
        optionValue="code"
        optionLabel="name"
        selectionLimit="1"
      ></p-multiSelect>
    </div>

    <button
      class="main-btn"
      type="submit"
      [ngClass]="{
        disabled: !delayReasonsForm.value.delay_reasons || disablePauseStart
      }"
      [disabled]="!delayReasonsForm.value.delay_reasons || disablePauseStart"
    >
      Sacuvaj <i class="pi pi-save"></i>
    </button>
  </form>
</p-dialog>
